import { render, staticRenderFns } from "./briefing.vue?vue&type=template&id=4eaa835b&"
import script from "./briefing.js?vue&type=script&lang=js&"
export * from "./briefing.js?vue&type=script&lang=js&"
import style0 from "./briefing.vue?vue&type=style&index=0&id=4eaa835b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports